/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderChallengeRules } from './LadderChallengeRules';
import {
    LadderChallengeRulesFromJSON,
    LadderChallengeRulesFromJSONTyped,
    LadderChallengeRulesToJSON,
    LadderChallengeRulesToJSONTyped,
} from './LadderChallengeRules';
import type { RankingSystem } from './RankingSystem';
import {
    RankingSystemFromJSON,
    RankingSystemFromJSONTyped,
    RankingSystemToJSON,
    RankingSystemToJSONTyped,
} from './RankingSystem';
import type { CompetitionFaq } from './CompetitionFaq';
import {
    CompetitionFaqFromJSON,
    CompetitionFaqFromJSONTyped,
    CompetitionFaqToJSON,
    CompetitionFaqToJSONTyped,
} from './CompetitionFaq';
import type { GlobalFilterExclusion } from './GlobalFilterExclusion';
import {
    GlobalFilterExclusionFromJSON,
    GlobalFilterExclusionFromJSONTyped,
    GlobalFilterExclusionToJSON,
    GlobalFilterExclusionToJSONTyped,
} from './GlobalFilterExclusion';
import type { LadderStatus } from './LadderStatus';
import {
    LadderStatusFromJSON,
    LadderStatusFromJSONTyped,
    LadderStatusToJSON,
    LadderStatusToJSONTyped,
} from './LadderStatus';
import type { LadderRatingConfig } from './LadderRatingConfig';
import {
    LadderRatingConfigFromJSON,
    LadderRatingConfigFromJSONTyped,
    LadderRatingConfigToJSON,
    LadderRatingConfigToJSONTyped,
} from './LadderRatingConfig';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { LadderActivityRules } from './LadderActivityRules';
import {
    LadderActivityRulesFromJSON,
    LadderActivityRulesFromJSONTyped,
    LadderActivityRulesToJSON,
    LadderActivityRulesToJSONTyped,
} from './LadderActivityRules';
import type { MatchFormat } from './MatchFormat';
import {
    MatchFormatFromJSON,
    MatchFormatFromJSONTyped,
    MatchFormatToJSON,
    MatchFormatToJSONTyped,
} from './MatchFormat';

/**
 * Ladder data returned from API endpoints
 * @export
 * @interface LadderResponse
 */
export interface LadderResponse {
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    matchModeId?: string;
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    ruleSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    sponsorId?: string;
    /**
     * 
     * @type {RankingSystem}
     * @memberof LadderResponse
     */
    rankingSystem?: RankingSystem;
    /**
     * 
     * @type {MatchFormat}
     * @memberof LadderResponse
     */
    matchFormat?: MatchFormat;
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof LadderResponse
     */
    scoringMode?: MatchScoringMode;
    /**
     * 
     * @type {LadderRatingConfig}
     * @memberof LadderResponse
     */
    ratingConfig?: LadderRatingConfig;
    /**
     * 
     * @type {LadderChallengeRules}
     * @memberof LadderResponse
     */
    challengeRules?: LadderChallengeRules;
    /**
     * 
     * @type {LadderActivityRules}
     * @memberof LadderResponse
     */
    activityRules?: LadderActivityRules;
    /**
     * 
     * @type {number}
     * @memberof LadderResponse
     */
    teamSize?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderResponse
     */
    maxParticipants?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderResponse
     */
    minRatingToJoin?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LadderResponse
     */
    requiresApproval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LadderResponse
     */
    isSeasonBased?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LadderResponse
     */
    seasonEndDate?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderResponse
     */
    standingsCount?: number;
    /**
     * 
     * @type {LadderStatus}
     * @memberof LadderResponse
     */
    status?: LadderStatus;
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    competitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    scoringTemplateId?: string;
    /**
     * 
     * @type {number}
     * @memberof LadderResponse
     */
    entryFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderResponse
     */
    collectedPrizePool?: number;
    /**
     * 
     * @type {string}
     * @memberof LadderResponse
     */
    payoutTableId?: string;
    /**
     * 
     * @type {number}
     * @memberof LadderResponse
     */
    minParticipants?: number;
    /**
     * Cheat-filtering match-bracketing gate — requires active Match Start / Round Start in Redis to score
     * @type {boolean}
     * @memberof LadderResponse
     */
    requireActiveMatch?: boolean;
    /**
     * 
     * @type {Array<CompetitionFaq>}
     * @memberof LadderResponse
     */
    faqs?: Array<CompetitionFaq>;
    /**
     * IDs of EventPipelineFilter documents applied to this ladder's events. Layered on top of the game-wide global filter; blocks when any assigned filter votes BLOCK (conditions AND-compose within each filter; exclude conditions block on match, include conditions block on non-match).
     * @type {Array<string>}
     * @memberof LadderResponse
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass per-entity exclusions of GLOBAL filters for this ladder (PRODUCT_PLAN D2(b)). Each entry names one global filter this ladder opts out of, with a required reason and a required absolute expiry. Evaluated as set membership against the blocking-filter ids stamped on the fan-out message; expiry is enforced at read.
     * @type {Array<GlobalFilterExclusion>}
     * @memberof LadderResponse
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusion>;
    /**
     * Rule 4 opt-out. When true this ladder still scores events whose match context is missing (the pre-Rule-4 behavior). Default false — a ladder that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof LadderResponse
     */
    failOpenOnMissingContext?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LadderResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderResponse
     */
    updatedAt?: number;
}



/**
 * Check if a given object implements the LadderResponse interface.
 */
export function instanceOfLadderResponse(value: object): value is LadderResponse {
    return true;
}

export function LadderResponseFromJSON(json: any): LadderResponse {
    return LadderResponseFromJSONTyped(json, false);
}

export function LadderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LadderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'matchModeId': json['matchModeId'] == null ? undefined : json['matchModeId'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'rankingSystem': json['rankingSystem'] == null ? undefined : RankingSystemFromJSON(json['rankingSystem']),
        'matchFormat': json['matchFormat'] == null ? undefined : MatchFormatFromJSON(json['matchFormat']),
        'scoringMode': json['scoringMode'] == null ? undefined : MatchScoringModeFromJSON(json['scoringMode']),
        'ratingConfig': json['ratingConfig'] == null ? undefined : LadderRatingConfigFromJSON(json['ratingConfig']),
        'challengeRules': json['challengeRules'] == null ? undefined : LadderChallengeRulesFromJSON(json['challengeRules']),
        'activityRules': json['activityRules'] == null ? undefined : LadderActivityRulesFromJSON(json['activityRules']),
        'teamSize': json['teamSize'] == null ? undefined : json['teamSize'],
        'maxParticipants': json['maxParticipants'] == null ? undefined : json['maxParticipants'],
        'minRatingToJoin': json['minRatingToJoin'] == null ? undefined : json['minRatingToJoin'],
        'requiresApproval': json['requiresApproval'] == null ? undefined : json['requiresApproval'],
        'isSeasonBased': json['isSeasonBased'] == null ? undefined : json['isSeasonBased'],
        'seasonEndDate': json['seasonEndDate'] == null ? undefined : json['seasonEndDate'],
        'standingsCount': json['standingsCount'] == null ? undefined : json['standingsCount'],
        'status': json['status'] == null ? undefined : LadderStatusFromJSON(json['status']),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'collectedPrizePool': json['collectedPrizePool'] == null ? undefined : json['collectedPrizePool'],
        'payoutTableId': json['payoutTableId'] == null ? undefined : json['payoutTableId'],
        'minParticipants': json['minParticipants'] == null ? undefined : json['minParticipants'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CompetitionFaqFromJSON)),
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function LadderResponseToJSON(json: any): LadderResponse {
    return LadderResponseToJSONTyped(json, false);
}

export function LadderResponseToJSONTyped(value?: LadderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'gameId': value['gameId'],
        'matchModeId': value['matchModeId'],
        'ruleSetId': value['ruleSetId'],
        'sponsorId': value['sponsorId'],
        'rankingSystem': RankingSystemToJSON(value['rankingSystem']),
        'matchFormat': MatchFormatToJSON(value['matchFormat']),
        'scoringMode': MatchScoringModeToJSON(value['scoringMode']),
        'ratingConfig': LadderRatingConfigToJSON(value['ratingConfig']),
        'challengeRules': LadderChallengeRulesToJSON(value['challengeRules']),
        'activityRules': LadderActivityRulesToJSON(value['activityRules']),
        'teamSize': value['teamSize'],
        'maxParticipants': value['maxParticipants'],
        'minRatingToJoin': value['minRatingToJoin'],
        'requiresApproval': value['requiresApproval'],
        'isSeasonBased': value['isSeasonBased'],
        'seasonEndDate': value['seasonEndDate'],
        'standingsCount': value['standingsCount'],
        'status': LadderStatusToJSON(value['status']),
        'createdBy': value['createdBy'],
        'competitionId': value['competitionId'],
        'scoringTemplateId': value['scoringTemplateId'],
        'entryFee': value['entryFee'],
        'collectedPrizePool': value['collectedPrizePool'],
        'payoutTableId': value['payoutTableId'],
        'minParticipants': value['minParticipants'],
        'requireActiveMatch': value['requireActiveMatch'],
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CompetitionFaqToJSON)),
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

